import { useQuery, type QueryClient } from '@tanstack/react-query';
import type { ConnectionState, Line } from '@chatapp-inbox/shared';
import { getConnection } from '../../api';
import { invalidateConversationLists, linesKey } from '../conversation';
import { connectionKey } from './keys';

/** A conexão do WhatsApp (campos, estado, números e o que a instalação oferece). */
export function useConnection() {
  return useQuery({
    queryKey: connectionKey,
    queryFn: ({ signal }) => getConnection(signal),
  });
}

/**
 * Registra um estado novo da conexão (resposta de salvar ou de procurar números). A lista de números
 * que o resto da interface usa (`GET /lines`) fica obsoleta: um número novo, ou um que sumiu e foi
 * desligado, muda o que a lista de conversas mostra.
 */
export function applyConnection(queryClient: QueryClient, connection: ConnectionState): void {
  queryClient.setQueryData(connectionKey, connection);
  void queryClient.invalidateQueries({ queryKey: linesKey });
}

/**
 * Registra um número que o servidor acabou de ligar ou desligar: troca-o no estado da conexão e
 * deixa obsoletos a lista de números ligados e as listas de conversas (desligar muda o que a
 * interface mostra do número e quais conversas podem enviar).
 */
export function applyLine(queryClient: QueryClient, line: Line): void {
  queryClient.setQueryData<ConnectionState | undefined>(connectionKey, (connection) =>
    connection
      ? { ...connection, lines: connection.lines.map((l) => (l.id === line.id ? line : l)) }
      : connection,
  );
  void queryClient.invalidateQueries({ queryKey: linesKey });
  void invalidateConversationLists(queryClient);
}
